import { buildProps, definePropType } from '../../../../utils/vue/props/runtime.mjs';

const alphaSliderProps = buildProps({
  color: {
    type: definePropType(Object),
    required: true
  },
  vertical: {
    type: Boolean,
    default: false
  }
});

export { alphaSliderProps };
//# sourceMappingURL=alpha-slider.mjs.map
